/* RESPONSIBLE TEAM: team-automation-foundations */
import type EmailOtp from 'embercom/models/operator/visual-builder/step/email-otp';
import StepConfig, { type StepConfigParams } from '../step';

export default class EmailOtpConfiguration extends StepConfig {
  declare step: EmailOtp;

  constructor(params: Omit<StepConfigParams, 'component'> & { component?: string }) {
    super({
      component: 'workflows/graph-editor/node-items/steps/email-otp',
      ...params,
    });
  }

  // No additional menu options needed - this is a simple step
  // The step automatically uses the user's email from the conversation
}
